<template>
  <div>
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="clipboard outline icon"></i>
        <div class="content">
          New Reservation Types
        </div>
      </h2>
    </div>
    <div class="ui divider"></div>
    <div class="ui fluid tiny steps">
      <div class="step"
          :class="{ active: currentTab == tabs.first }">
        <i class="truck icon"></i>
        <div class="content">
          <div class="title">Reservation Type</div>
          <div class="description">Enter reservation type information</div>
        </div>
      </div>

      <div class="step"
           :class="{ active: currentTab == tabs.second }">
        <i class="payment icon"></i>
        <div class="content">
          <div class="title">Default Package</div>
          <div class="description">Enter default package information</div>
        </div>
      </div>

      <div class="step"
           :class="{ active: currentTab == tabs.third }">
        <i class="info icon"></i>
        <div class="content">
          <div class="title">Confirm Data</div>
          <div class="description">Verify reservation type details</div>
        </div>
      </div>
    </div>

    <div class="ui grid" style="padding-top: 30px;">
      <keep-alive>
        <reservationTypeInfoStep
          @reservationType-step1Changes="step1EventListenner"
          style="width: 100%"
          v-if="currentTab == tabs.first"
        />
      </keep-alive>

      <keep-alive>
        <defaultPackageInfoStep
          @reservationType-step2Changes="step2EventListenner"
          @reservationType-goToStepOne="currentTab = tabs.first"
          style= "width: 100%"
          v-if="currentTab == tabs.second"
        />
      </keep-alive>

      <reviewStep
        @reservationType-confirmation="save()"
        @reservationType-goToStepTwo="currentTab = tabs.second"
        style="width: 100%"
        v-if="currentTab == tabs.third"
        :reservationType="step1Data"
        :defaultPackage="step2Data"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    reservationTypeInfoStep: require('@/components/steps/reservation_types/new_reservation_type_steps/ReservationTypeInfoStep').default,
    defaultPackageInfoStep: require('@/components/steps/reservation_types/new_reservation_type_steps/DefaultPackageInfoStep').default,
    reviewStep: require('@/components/steps/reservation_types/new_reservation_type_steps/ReviewStep').default
  },
  data () {
    return {
      currentTab: 'reservationType',
      tabs: {
        first: 'reservationType',
        second: 'defaultPackage',
        third: 'review'
      },
      step1Data: {},
      step2Data: {}
    }
  },
  mounted () {
    this.initGUI()
  },
  methods: {
    initGUI () {
      this.$nextTick(() => {
        $('#start-at').calendar({
          type: 'datetime',
          onChange: (date) => {
            this.reservationType.default_package.start_at = date
          }
        })

        $('#unit-measurment-id').dropdown()
        $('#multi-select').dropdown()
      })
    },
    step1EventListenner (event) {
      this.step1Data = event.data.reservationTypeInfo
      if (event.data.next) {
        this.currentTab = this.tabs.second
      }
    },
    step2EventListenner (event) {
      this.step2Data = event.data.defaultPackageInfo
      if (event.data.next) {
        this.currentTab = this.tabs.third
      }
    },
    formatData () {
      let duration =
        (this.step1Data.hours * 3600) + (this.step1Data.minutes * 60)

      return {
        name: this.step1Data.name,
        price: this.step1Data.price,
        duration: duration,
        default_package: {
          quantity: this.step2Data.quantity,
          unit_measurement_id: this.step2Data.unit_measurement_id,
          start_at: this.step2Data.start_at,
          description: this.step2Data.description,
          medical_machines: this.step2Data.medical_machines
        }
      }
    },
    save () {
      this.$http.post('reservation_types', { reservation_type: this.formatData() }).then(response => {
        this.getReservationTypes().then(() => {
          this.navigateTo('Clinic_Settings')
        })
      })
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/reservation_types/NewReservationType.vue